export default __webpack_public_path__ + "static/form-multiple-action-buttons-dont-10cc1e1bebc17bd376aa68f0ffdcd9db6789367f23d79f7f7a5433097f13400f.png";